import * as React from 'react';
import { SVGProps } from 'react';

export const GradebookAttachmentSVG = ({
    stroke = '#3B516A',
    ...props
}: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M11.5 1.75c1.963 0 3.417 1.416 3.417 3v9c0 2.413-2.2 4.5-5.084 4.5M11.5 1.75c-1.963 0-3.417 1.416-3.417 3v9c0 .756.708 1.5 1.75 1.5M11.5 1.75c-1.719 0-3.25 1.27-3.25 3v9c0 .9.785 1.5 1.583 1.5M11.5 1.75c1.719 0 3.25 1.27 3.25 3v9c0 2.558-2.278 4.5-4.917 4.5m0-3c1.043 0 1.75-.744 1.75-1.5v-7.5h-.166v7.5c0 .9-.785 1.5-1.584 1.5Zm0 3c-2.639 0-4.916-1.942-4.916-4.5V8.5H4.75v5.25c0 2.413 2.2 4.5 5.083 4.5Z"
            stroke={stroke}
            strokeWidth={1.5}
        />
    </svg>
);

export const GradebookAnnotationsSVG = ({
    stroke = '#3B516A',
    ...props
}: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M15.724 6.866 7.913 14.74 3 15.56l.819-4.914 7.875-7.81a2.847 2.847 0 0 1 4.03 0 2.848 2.848 0 0 1 0 4.03ZM11.076 3.943l3.79 3.782M3.819 10.646l4.094 4.094M2.5 17.5h15"
            stroke={stroke}
            strokeWidth={props.strokeWidth || 1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const GradebookAnnotationPostedSVG = ({
    variant = 'gray',
    ...props
}: SVGProps<SVGSVGElement> & { variant?: 'green' | 'gray' }) => {
    const stroke = variant === 'green' ? '#43B75D' : '#637488';
    const fill = variant === 'green' ? '#E1F3E5' : 'transparent';
    return <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M1.25 4.08333C1.25 2.97876 2.14543 2.08333 3.25 2.08333H16.75C17.8546 2.08333 18.75 2.97876 18.75 4.08333V15.0833C18.75 16.1879 17.8546 17.0833 16.75 17.0833H12.9385C12.817 17.0833 12.6997 17.1276 12.6085 17.2077L10.3301 19.2099C10.1413 19.3758 9.85876 19.3758 9.66999 19.2099L7.39162 17.2077C7.30037 17.1276 7.18304 17.0833 7.06157 17.0833H3.25C2.14543 17.0833 1.25 16.1879 1.25 15.0833V4.08333Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M4.58301 12.9167H6.24967" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path
            d="M15.8445 8.63951L11.9926 12.4914L9.58301 12.9167L10.0082 10.5071L13.8602 6.65517C14.1251 6.39547 14.4813 6.25 14.8523 6.25C15.2233 6.25 15.5796 6.39547 15.8445 6.65517C16.1042 6.92012 16.2497 7.27634 16.2497 7.64734C16.2497 8.01834 16.1042 8.37456 15.8445 8.63951Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M4.58301 9.58333H7.91634" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.58301 6.25H10.4163" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
};